import React from "react";
import ReactTooltip from "react-tooltip";
import classnames from "classnames";
import "./Tooltip.css";

const Tooltip = ({ id, children, className, style }) => {
  return (
    <div
      style={{ ...{ position: "relative" }, ...style }}
      className={classnames("d-inline-block", className)}
    >
      {/* eslint-disable-next-line */}
      <a data-tip data-for={id}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          className="bi bi-exclamation-circle"
          viewBox="0 0 16 16"
        >
          <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
          <path d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995z" />
        </svg>
      </a>
      <ReactTooltip
        id={id}
        place="bottom"
        type="dark"
        effect="solid"
        textColor="white"
        arrowColor="red"
        borderColor="red"
        border
        multiline
      >
        <div style={{ maxWidth: 250 }}>
          <p className="tool-content">{children}</p>
          <hr className="top-hr" />
        </div>
      </ReactTooltip>
    </div>
  );
};

export default Tooltip;
